const IE9 = /MSIE 9/i.test(navigator.userAgent);
const IE10 = /MSIE 10/i.test(navigator.userAgent);
const isIE = 'onmspointerleave' in window || IE9 || IE10;

const installWindowOpenWithNoopener = () => {
    if (window.open_noopener) return;
    window.open_noopener = (strUrl, strWindowName, strWindowFeatures, isForce) => {
        if (isIE || isForce) {
            let windowObj = window.open(strUrl, strWindowName);
            windowObj.opener = null;
            windowObj = null;
        } else {
            window.open(strUrl, strWindowName, strWindowFeatures);
        }
    };
};

installWindowOpenWithNoopener();
